export default __webpack_public_path__ + "6c21ad3ada305be57801b52fb084ffb6.png";